import { render, staticRenderFns } from "./inviteIndex.vue?vue&type=template&id=16d04f6a"
import script from "./inviteIndex.vue?vue&type=script&lang=js"
export * from "./inviteIndex.vue?vue&type=script&lang=js"
import style0 from "./inviteIndex.vue?vue&type=style&index=0&id=16d04f6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports